interface Window {
  interact: any;
}

function getSrcDoc(
  kind: string,
  elementContent: string,
  templateContent: string
) {
  return `<html><head><style>body{margin:4px; color: salmon; }</style><style data-style-inject>${
    kind == "css" ? elementContent : ""
  }</style></head><body>${templateContent}<div data-html-inject>${
    kind === "html" ? elementContent : ""
  }</div></body></html>`;
}

document.addEventListener("DOMContentLoaded", function () {
  const liveElementSelector = '[class$=":live"]';
  const liveCodeClass = "awa-live-code";
  const resizableClass = "awa-resizable";
  const supportedCodeKinds = ["css", "html"] as const;
  const iframeDemoClass = "awa-iframe-demo";
  const resizeIcon = document.createElement("span");
  resizeIcon.setAttribute(
    "style",
    "position: absolute; right: 0; bottom: 0; height:24px"
  );
  resizeIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22 22h-2v-2h2v2m0-4h-2v-2h2v2m-4 4h-2v-2h2v2m0-4h-2v-2h2v2m-4 4h-2v-2h2v2m8-8h-2v-2h2v2Z"/></svg>`;
  const liveCodeStyleElement = document.createElement("style");
  liveCodeStyleElement.innerHTML = `
        .${iframeDemoClass} {
            width: 100%;
            overflow: hidden;
            outline: 1px dashed #1bc183;
            min-height: 150px;
            position: relative;
            display: flex;
            flex-direction: column;
            margin-bottom: var(--space-md);
            justify-content: space-between;
        }

        .${resizableClass} {
            touch-action: none;
            box-sizing: border-box;
            padding: 0 1rem 1rem 0;
        }

        .${iframeDemoClass}::before {
            content: 'Demo';
            top: 0;
            align-self: baseline;
            right: 0;
            background-color: #1bc183;
            color: #fff;
            padding: 0.2em 0.5em;
            font-size: 0.8em;
            font-weight: bold;
            border-bottom-right-radius: 0.2em;
        }

        .${iframeDemoClass} iframe {
            width: 100%;
            border: none;
            flex: 1 0 auto;
        }

        .${liveCodeClass} [contenteditable="true"] {
            outline: none;
        }
        .${liveCodeClass} {
            position: relative;
            outline: 1px dashed #f00;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .${liveCodeClass}::before {
            content: 'Live';
            align-self: baseline;
            transform: translate(-0.5rem,-0.5rem);
            top: 0;
            right: 0;
            background-color: #f00;
            color: #fff;
            padding: 0.2em 0.5em;
            font-size: 0.8em;
            font-weight: bold;
            border-bottom-right-radius: 0.2em;
        }`;
  document.head.appendChild(liveCodeStyleElement);
  type SupportedCodeKind = (typeof supportedCodeKinds)[number];

  function isSupportedCodeKind(
    kind?: string | null
  ): kind is SupportedCodeKind {
    return (
      kind != null && supportedCodeKinds.includes(kind as SupportedCodeKind)
    );
  }

  function makeAllResizable() {
    window.interact("." + resizableClass).resizable({
      edges: { bottom: true, right: true },
      listeners: {
        move: function (event: any) {
          let { x, y } = event.target.dataset;

          x = (parseFloat(x) || 0) + event.deltaRect.left;
          y = (parseFloat(y) || 0) + event.deltaRect.top;

          Object.assign(event.target.style, {
            width: `${event.rect.width}px`,
            height: `${event.rect.height}px`,
            transform: `translate(${x}px, ${y}px)`,
          });

          Object.assign(event.target.dataset, { x, y });
        },
      },
    });
  }

  function getCodeKind(element: HTMLElement): SupportedCodeKind | null {
    const className = element.className;
    const match = className.match(/language-(\w+)/);
    if (match && isSupportedCodeKind(match[1])) {
      return match[1];
    }
    return null;
  }

  function addLiveCodeClassToParent(element: HTMLElement): boolean {
    const parent = element.parentElement;
    if (parent && parent.tagName === "PRE") {
      parent.classList.add(liveCodeClass);
      return true;
    }
    return false;
  }

  function observeChanges(
    element: HTMLElement,
    kind: SupportedCodeKind,
    iframe: HTMLIFrameElement
  ) {
    let inIframeTargetSelector = "";
    const [, templateUuid] = element.className.split(":");
    const templateContent = document.getElementById(
      templateUuid + "-template"
    )?.innerHTML;
    console.log(element.className.split(":"));
    switch (kind) {
      case "css":
        inIframeTargetSelector = "style[data-style-inject]";
        break;
      case "html":
        inIframeTargetSelector = "div[data-html-inject]";
        break;
    }
    if (kind === "css") {
      const styleElement = document.createElement("style");
      document.head.appendChild(styleElement);
      console.log("Applying code", element.innerText, "to", styleElement);
    } else if (kind === "html") {
      console.log("HTML Kind is used");
    }
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === "characterData") {
          if (kind === "html") {
            iframe.srcdoc = getSrcDoc(
              kind,
              element.textContent,
              templateContent!
            );
          } else {
            iframe.contentDocument!.querySelector(
              inIframeTargetSelector
            )!.innerHTML = element.textContent || "";
          }
        }
      }
    });
    observer.observe(element, { characterData: true, subtree: true });
  }

  function makeContentEditable(element: HTMLElement): boolean {
    element.contentEditable = "true";
    element.spellcheck = false;
    return true;
  }

  function addIFrameWithSrcDoc(
    element: HTMLElement,
    srcTemplate: HTMLTemplateElement,
    kind: SupportedCodeKind
  ): HTMLIFrameElement {
    const iframe = document.createElement("iframe");
    const iframeContainer = document.createElement("div");
    iframeContainer.classList.add(iframeDemoClass);
    iframeContainer.classList.add(resizableClass);
    iframeContainer.setAttribute(
      "style",
      srcTemplate.getAttribute("style") || ""
    );
    iframeContainer.appendChild(iframe);
    iframeContainer.appendChild(resizeIcon.cloneNode(true) as HTMLElement);
    const elementContent = element.textContent;
    let srcDoc = srcTemplate.innerHTML;
    iframe.setAttribute(
      "sandbox",
      "allow-scripts allow-forms allow-same-origin"
    );
    if (!srcDoc.includes("<html>")) {
      //assume that srcdoc is only body
      srcDoc = getSrcDoc(kind, elementContent, srcDoc);
    }
    iframe.srcdoc = srcDoc;
    element.parentElement?.insertAdjacentElement("afterend", iframeContainer);
    return iframe;
  }

  function makeLiveCodeChainOfResponsibility(element: HTMLElement) {
    const codeKind = getCodeKind(element);
    if (codeKind == null) return;
    const [, uuid] = element.className.split(":");
    const srcTemplate = document
      .getElementById(uuid + "-template")
      ?.cloneNode(true) as HTMLTemplateElement;
    const iframe = addIFrameWithSrcDoc(element, srcTemplate, codeKind);
    addLiveCodeClassToParent(element) &&
      makeContentEditable(element) &&
      observeChanges(element, codeKind, iframe);
  }

  const allLiveCodes = Array.from(
    document.querySelectorAll<HTMLElement>(liveElementSelector) || []
  );
  allLiveCodes.forEach(makeLiveCodeChainOfResponsibility);
  makeAllResizable();
  // Start observing the node for changes
});
